import { Component, OnInit } from "@angular/core";
import { PageLayout } from "@cvx/nextpage";
import { NumberOfMonths } from "src/app/models/charts/by-request-type/numberOfMonths.enum";
import { WorkflowRequestTypes } from "src/app/models/requests/enums/WorkflowRequestTypes.enum";
import { IWorkflowRequest } from "src/app/models/requests/WorkflowRequest";
import { WorkflowRequestService } from "src/app/services/workflow/WorkflowRequestService";


@Component({
    selector: 'main-dashboard',
    templateUrl: './dashboard-main.component.html'
})

export class MainDashboardComponent implements OnInit {
    isLoading: boolean = true;
    allWorkflowRequests: IWorkflowRequest[] = [];
    workflowRequestsByType = new Map<WorkflowRequestTypes, IWorkflowRequest[]>();
    numberOfMonths: NumberOfMonths = NumberOfMonths.LastThreeMonths; // Default to last 3 months
    readonly allRequestsBarColor = '#009DD9';

    constructor(private workflowRequestService: WorkflowRequestService) { }

    ngOnInit(): void {
        this.getWorkflowRequestData();
    }

    getWorkflowRequestData() {
        this.isLoading = true;
        this.allWorkflowRequests = [];
        this.workflowRequestService.GetByType(WorkflowRequestTypes.None, this.numberOfMonths).subscribe({
            next: (response) => {
                this.allWorkflowRequests = response.data;
                //this.loadWorkflowRequestByTypeChartData();
                this.isLoading = false;
            }
        });
    }
    loadWorkflowRequestByTypeChartData() {
        this.workflowRequestTypeKeys.forEach((item) => {
            const type = item.value;
            const requests = this.allWorkflowRequests.filter((request) => request.type === type);
            this.workflowRequestsByType.set(type, requests);
        });
        this.isLoading = false;
    }

    PageLayout = PageLayout;
    allRequestType: WorkflowRequestTypes = WorkflowRequestTypes.None;

    readonly workflowRequestTypeKeys = Object.keys(WorkflowRequestTypes)
        .filter((key) => isNaN(Number(key)) && key !== WorkflowRequestTypes.None)
        .map((key) => ({
            displayName: key,
            value: WorkflowRequestTypes[key as keyof typeof WorkflowRequestTypes],
        }))
        .sort((a, b) => a.displayName.localeCompare(b.displayName));
}
